import { spacing } from '../../style';

const borderRadiusConstants = {
  round: '50%',
  md: spacing.xxs,
  lg: spacing.xs,
};

export { borderRadiusConstants };
